// @ts-nocheck
import $ from 'jquery';
import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';
import PlugSolid from '../images/PlugSolid.svg';
import BatteryIndicator from '../images/BatteryIndicator.svg';
import UnPlug from '../images/Unplug.svg';

const chassisFormatter = {
    ChassisPWRSorting: (params) => {
        //return "-NA-";
        if (params.data != null && params.data != undefined) {
            if (params.data.PWR != null && params.data.PWR != undefined) {
                switch (params.data.PWR.toString().toUpperCase().trim()) {
                    case "A":
                        return "1";
                    case "B":
                        return "2";
                    //case "N":
                    //    return "3";
                }
            }
            return "3";
        }
        return "3";
    },
    ChassisPwrStateFormatterFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.PWR != null && params.data.PWR != undefined) {

                switch (params.data.PWR.toString().toUpperCase().trim()) {
                    case "1":
                    case "A":
                        title = "Powered";
                        break;
                    case "2":
                    case "B":
                        title = "On Battery";
                        break;
                    case "3":
                        title = "-NA-";
                        break;
                }
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },
    pwrStateFormatterChassis: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.PWR != null && params.data.PWR != undefined) {
                var element = document.createElement("span");
                element.className = "pwr_grid_icon";
                var imageElement = document.createElement("img");

                switch (params.data.PWR.toString().toUpperCase().trim()) {
                    case "A":
                        element.className = "PlugSolid";
                        element.title = "Powered"
                        imageElement.src = PlugSolid;
                        break;
                    case "B":
                        element.className = "PlugSolid";
                        element.title = "On Battery"
                        imageElement.src = UnPlug;
                        break;
                }
                element.appendChild(imageElement);
                return element;
            }
        }
        //return '-NA-';
        return "-NA-";
    },
    chassisBatteryStatusSorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.ChassisBatteryStatus != null && params.data.ChassisBatteryStatus != undefined) {
                switch (params.data.ChassisBatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        return "1";
                    case "L":
                        return "2";
                    case "N":
                        return "3";
                }
            }
            return "-1";
        }
        return "-1";
    },
    chassisBatteryStatusFormatterFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.ChassisBatteryStatus != null && params.data.ChassisBatteryStatus != undefined) {
                switch (params.data.ChassisBatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        title = "Critical";
                        break;
                    case "L":
                        title = "Low";
                        break;
                    case "N":
                        title = "Normal";
                        break;
                }               
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";
        return title;
    },
    chassisBatteryStatusFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.ChassisBatteryStatus != null && params.data.ChassisBatteryStatus != undefined) {
                var element = document.createElement("span");
                element.className = "pwr_grid_icon";
                var imageElement = document.createElement("img");

                switch (params.data.ChassisBatteryStatus.toString().toUpperCase().trim()) {
                    case "C":
                        imageElement.src = batterycritical;
                        break;
                    case "L":
                        imageElement.src = batterylow;
                        break;
                    case "N":
                        imageElement.src = batterynormal;
                        break;
                }
                element.appendChild(imageElement);
                return element;
            }
        }
        return '-NA-';
    },
    SpeedConverterChassisFilter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.data.ChassisSpeed != null) {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = params.data.ChassisSpeed;
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params.data.ChassisSpeed);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },

    ChassisSpeedConverter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.value != null && params.value != '-NA-') {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = params.value;
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params.value);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },

    LoadedValueFormatter: (param) => {
        if (param != null) {
            if (param.toString().toUpperCase().trim() == "TRUE")
                return "Loaded";
            else
                return "Empty";
        }
        else
            return '-NA-';
    },

    LoadedFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().toUpperCase().trim() == "TRUE")
                return "Loaded";
            else
                return "Empty";
        }
        else
            return '-NA-';
    },

    LoadedFormatterFilter: (params) => {
        var returnValue = "";
        if (params.data.Loaded != null) {
            if (params.data.Loaded.toString().toUpperCase().trim() == "TRUE")
                returnValue = "Loaded";
            else
                returnValue = "Empty";
        }
        else
            returnValue = '-NA-';

        return returnValue;
    },

    BrakeSignalFormatter: (params) => {

        return "-NA-";
    },

    BrakeSignalSorting: (params) => {
        return "-NA-";
    },
}

export default chassisFormatter;